import React, { useContext, useState } from "react";

import ICONS from "../../constants/icons";

import styles from "./orderCompleteModal.module.css";
import { useAppContext } from "../../../context/AppContext";
import { RichText } from "prismic-reactjs";

const OrderCompleteModal = ({
  copy,
  title,
}: {
  title?: string;
  copy?: any;
}): JSX.Element => {
  const { settings } = useAppContext();

  return (
    <div className={styles.container}>
      <div className={styles.modalLeft}>
        <div className={styles.description}>
          <div className={styles.modalTitle}>
            {title || settings?.data?.orderConfirmationPopupTitle}
          </div>
          <div className={styles.modalBody}>
            {copy ? (
              copy
            ) : (
              <RichText render={settings?.data?.orderConfirmationCopy} />
            )}
          </div>
        </div>

        <ICONS.ORLOGO size={100} />
      </div>
      <div
        className={styles.modalRight}
        style={{
          backgroundImage: `url(${settings?.data?.orderConfirmationPopupImage.url})`,
        }}
      ></div>
    </div>
  );
};

export default OrderCompleteModal;
